<template>
    <div class="ks-close-wrapper" :class="{'ks-close-wrapper-hasnav': hasnav}">
        <router-link class="ks-close" :class="`ks-close-${$route.params.route || $route.name}`" v-if="to"  :to="to">
            <span/>
            <span/>
        </router-link>
        <a class="ks-close" :class="`ks-close-${$route.params.route || $route.name}`" v-else v-on:click.prevent="$router.go(-1)" href="/">
            <span/>
            <span/>
        </a>
    </div>
</template>

<script>

/* eslint-disable */

export default {
  name: 'Closetag',
  props: ['force', 'hasnav'],
  data() {
    let _to = {};
    if (this.force) {
        if (typeof this.force === 'string') {
            _to = {name: this.force}
        } else {
            _to = this.force
        }
    } else {
        if (window.previousUrl === '/') {
            _to = {name: 'home'}
        }
        else {
            _to = false
        }
    }
    return({
        to: _to
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    
@import '../main';

.ks-close {
    $height: 3rem;
    cursor: pointer;
    height: $height;
    width: $height;
    border-radius: $height;    
    background: white;
    padding: 0;
    margin: 0;
    border: var(--line-width) solid;
    display: block;
    @include flex-vertical-center();
    @include sm() {
        height: $height / 1.6;
        width: $height / 1.6;
        border-radius: $height / 1.6;
    }
    span {
        border-left: var(--line-width) solid black;
        transform: rotate(-45deg) translateY(1px);
        height: $height - 1rem;
        @include sm() {
            height: ($height / 1.6) - 0.5rem;
        }
        &:last-child {
            transform: rotate(45deg) translateY(1px);
        }
    }

    transition: all 0.25s;
    
    @media (hover: hover) {
        &:hover {
            transform: scale(1.1);
        }
    }

    &-wrapper {
        top: calc(0px - 1.75rem);
        @include sm() {
            top: calc(0px - 0.75rem);
        }
        @include responsive($sticky-height, 'height');
        z-index: 2000;
        position: sticky;
        padding-right: var(--pd1);
        padding-left: var(--pd1);
        @include flex-vertical-center();
        float: right;
        &-hasnav {
            @include responsive($nav-height, 'height');
            // background: rgb(255,255,255);            
            top: 0rem;
            &:before {
                content: "";
                width: var(--pd1);
                height: 100%;
                position: absolute;
                // background: rgb(255,255,255);
                // background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) var(--pd1));
                left: calc(0px - var(--pd1));
            }
        }
    }

    &-projekte {
        span,
        & {
            border-color: $ks-pink;
        }
    }
    &-stiftung {
        span,
        & {
            border-color: $ks-green;
        }
    }
    &-anmeldung,
    &-new,
    &-news {
        span,
        & {
            border-color: $ks-blue;
        }
    }
    &-calls {
        span,
        & {
            border-color: $ks-blue;
        }
    }
    &-gesuche {
        span,
        & {
            border-color: $ks-yellow;
        }
    }
    &-kontakt {
        span,
        & {
            border-color: $ks-dark-grey;
        }
    }
} 
</style>



      


// WEBPACK FOOTER //
// src/components/Closetag.vue